/*
 * GardenPack free-shipping bar for the Sternify cart drawer (aside.sd-drawer).
 *
 * Sternify's own free-shipping goal is set in its app and does not match the
 * store's shipping rate (free from $70 in the US). Without touching Sternify,
 * this rewrites its bar after each drawer render from the real cart total
 * (/cart.js total_price, after discounts, like Shopify's rate condition) and the
 * theme setting "GardenPack free shipping": "Add $X to unlock…" below the goal,
 * the unlocked message and a full bar at or above it, or (setting "Bundles always
 * ship free") whenever the cart holds a bundle-app line of the bundle quantity.
 * The last known total is applied straight away on every render so Sternify's
 * figure does not flash, then the cart is re-read and applied again.
 */
(() => {
  const configEl = document.getElementById('gp-freeship-config');
  if (!configEl) return;
  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (error) {
    return;
  }
  const goal = Number(config.goalCents) || 0;
  if (goal <= 0) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let total = null;
  let bundleInCart = false;
  let currency = config.currency || 'USD';
  let timer = null;
  let request = null;

  const money = (cents) =>
    new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);

  const paint = () => {
    if (total === null) return;
    const box = document.querySelector('.sd-drawer .sd-freeship');
    if (!box) return;
    const done = total >= goal || bundleInCart;
    const percent = done ? 100 : Math.max(0, Math.min(100, (total / goal) * 100));
    const text = done
      ? config.doneText
      : (config.text || '').replace('[amount]', money(goal - total));

    const label = box.querySelector('.sd-freeship__text span') || box.querySelector('.sd-freeship__text');
    if (label && text && label.textContent !== text) label.textContent = text;

    const bar = box.querySelector('.sd-freeship__bar');
    const value = String(Math.round(percent));
    if (bar && bar.getAttribute('aria-valuenow') !== value) bar.setAttribute('aria-valuenow', value);

    // Same width formula as Sternify (the 14px leaves room for the milestone icon).
    const fill = box.querySelector('.sd-freeship__fill');
    const width = done ? '100%' : `calc(${percent}% - 14px)`;
    if (fill && fill.style.width !== width) fill.style.width = width;

    box.classList.toggle('gp-freeship--done', done);
  };

  const refresh = async () => {
    request?.abort();
    request = new AbortController();
    try {
      const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, signal: request.signal })).json();
      total = cart.total_price;
      bundleInCart = Boolean(config.bundleFree) && cart.items.some((item) =>
        item.quantity >= (Number(config.bundleMinQty) || 2) && item.properties && item.properties[config.bundleProperty]);
      currency = cart.currency || currency;
    } catch (error) {
      return;
    }
    paint();
  };

  const schedule = () => {
    paint();
    clearTimeout(timer);
    timer = setTimeout(refresh, 150);
  };

  const inDrawer = (record) => {
    const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
    if (target && target.closest('.sd-drawer')) return true;
    return [...record.addedNodes].some((n) => n.nodeType === 1 && (n.matches('.sd-drawer') || n.querySelector('.sd-drawer')));
  };

  // paint() only writes when a value differs, so its own edits settle after one pass.
  const observer = new MutationObserver((records) => {
    if (records.some(inDrawer)) schedule();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  schedule();
})();
